import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import React from 'react';
import HeaderCell from '../../../components/shared/headercell/HeaderCell.js';
import {formatDateTimeString} from "../../../helpers/helperfunctions.js";
import PopOverDialog from '../../../components/shared/popoverdialog/PopOverDialog.js'

/**
 * @param className
 * @param {[object]} loginList
 * @param {{sortValue: string, sortDirection: 'asc' | 'desc'}} sort
 * @param {function} sortHandler
 * @returns {JSX.Element}
 * @constructor
 */
export default function AdminOperationsLoginTableBody({className, loginList, sort, sortHandler}) {
    const tableHeaderList = [
        {
            name: "Tidspunkt",
            sortValue: "createdDateTime",
            type: "string",
            display: "d-table-cell"
        },
        {
            name: 'email',
            sortValue: "userEmail",
            type: "string",
            display: "d-table-cell"
        },
        {
            name: "Success",
            sortValue: "accessStatus",
            type: "string",
            display: "d-table-cell"
        },
        {
            name: 'Lokation',
            sortValue: "to",
            type: "string",
            display: "d-table-cell"
        },
        {
            name: 'Klient',
            sortValue: "subject",
            type: "string",
            display: "d-table-cell"
        }
    ]

    return (
        <div className={className}>
            <TableContainer className="pe-0 ps-0" sx={{}}>
                <Table stickyHeader aria-label="simple table">
                    <TableHead>
                        <TableRow hover>
                            {tableHeaderList.map((obj, i) => {
                                let sx = {backgroundColor: "#ededed", borderRight: "1px solid #d9d9d9"}
                                if (i === 0) {
                                    sx = {
                                        backgroundColor: "#ededed",
                                        borderRight: "1px solid #d9d9d9",
                                        borderTopLeftRadius: "0.8rem"
                                    }
                                } else if (i === tableHeaderList.length - 1) {
                                    sx = {backgroundColor: "#ededed", borderTopRightRadius: "0.8rem"}
                                }
                                return <HeaderCell key={obj.name} sortHandler={sortHandler} headerObj={obj}
                                                   sort={sort} sx={sx} alignment={"center"}
                                                   className={obj.display}/>
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loginList.map(row => (
                            <TableRow
                                key={row.id}
                                sx={{
                                    backgroundColor: 'white',
                                    "td": {
                                        borderBottom: "1px solid #d9d9d9",
                                        borderTop: "1px solid #d9d9d9",
                                        borderLeft: "1px solid #d9d9d9"
                                    },
                                    "td:last-child": {
                                        borderRight: "1px solid #d9d9d9"
                                    }
                                }}>

                                <TableCell className="d-table-cell"
                                           align="left">{formatDateTimeString(row.createdDateTime, true, true, true)}</TableCell>
                                <TableCell className="d-table-cell" align="left">{row.userEmail}</TableCell>
                                <TableCell className="d-table-cell" align="left">
                                    {row.accessStatus === "success" ? "Ja" : "Nej"}
                                    {row.accessStatus !== "success" && <PopOverDialog popOverTitel={'Fejlårsag'}
                                                                                      popOverContent={<React.Fragment>
                                                                                          <p>{row.statusFailureReason}</p>
                                                                                          <p>{row.statusAdditionalDetails}</p>
                                                                                      </React.Fragment>}
                                                                                      trigger={['hover', 'touch']}
                                                                                      size={'lg'}/>}
                                </TableCell>
                                <TableCell className="d-table-cell"
                                           align="left">{row.countryOrRegion} - {row.city}</TableCell>
                                <TableCell className="d-table-cell"
                                           align="left">{row.operatingSystem ? `${row.operatingSystem} - ${row.browser}` : row.browser}</TableCell>

                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}